import React, { Component } from 'react'
import MainColCP from '../structure/MainColCP'
import GameHistoryCP from './GameHistoryCP'
import GamePlayersCP from './GamePlayersCP'
import '../structure/main-col-cp.css'
import './game-sidebar-cp.css'

class GameSidebarCP extends Component {
  constructor() {
    super();
    // this.state = {}
  }

  render() {
    return (
      <div className="main-v-col main-col-history-game">
        <MainColCP className='v-col-players' title="players">
          <GamePlayersCP />
        </MainColCP>
        <MainColCP className='v-col-history main-col-scrollable' title="moves">
          <GameHistoryCP />
        </MainColCP>
      </div>
    )
  }
}

export default GameSidebarCP
